// eslint-disable-next-line
export enum DialogType {
  message,
  confirm,
  yesNo,
}
